import React from 'react';
import { useHistory } from 'react-router';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { IconArrowBack } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { QuirkIonPage } from '../components/QuirkIonPage';
import { SettingsMenuContent } from '../components/SettingsMenuContent';

export const SettingsMenu: React.FC<{}> = () => {
	const history = useHistory();

	return (
		<QuirkIonPage roles={['anonymous', 'user']} name="Settings Menu">
			<>
				<Header
					title={'Settings'}
					left={<IconButton icon={<IconArrowBack />} onClick={() => history.go(-1)} />}
				/>
				<QuirkIonContent>
					<SettingsMenuContent />
				</QuirkIonContent>
			</>
		</QuirkIonPage>
	);
};
